import { Pipe, PipeTransform, TrackByFunction } from '@angular/core';

@Pipe({ name: 'trackByKey' })
export class TrackByKeyPipe<T> implements PipeTransform {
  transform(key: null | keyof T): TrackByFunction<T> {
    return (index: number, item: T) => (key ? item[key] : item);
  }
}
